import { AppBar, Box, Button, Divider, Toolbar, Typography } from "@mui/material"
import React from "react"
import AddCardIcon from '@mui/icons-material/AddCard';
import HeaderDispatch from "./model";
import HeaderState, { Hstate } from "../../State/HeaderState";
import PaymentDialog from "../../SubComponent/UI/PaymentDialog";
import { payment } from "../../../../../../config/api";

class Header extends React.Component<{}>{
    render() {

        let dispatcher: HeaderDispatch = (this.props as any).dispatcher
        let state: Hstate = (this.props as any).state

        return (
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="fixed">
                    <Toolbar>
                        {/* <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                        >
                            <MenuIcon />
                        </IconButton> */}
                        <Typography variant="subtitle1" component="div" sx={{ mr: 2 }}>
                            وبســایت جامــع خدمــات
                        </Typography>
                        <Typography variant="h6" component="div" sx={{ mr: 2, fontFamily: 'font-farsi-logo' }}>
                            فایلـــچرخ
                        </Typography>
                        <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />

                        <Button
                            sx={{ my: 2, color: 'white', display: 'block' }} onClick={() => {
                                dispatcher.mainPage()
                            }}>
                            صفحه اصلی
                        </Button>

                        <Box sx={{ flexGrow: 1 }} />

                        <Button variant="contained" startIcon={<AddCardIcon sx={{ ml: 1 }} />} color="secondary" size='small' onClick={() => {
                            dispatcher.payment(true)
                        }}>
                            شارژ کیف پول
                        </Button>
                    </Toolbar>
                </AppBar>

                <PaymentDialog isOpen={state.header.paymentDialogIsOpen} onPayClicked={(amount) => {
                    dispatcher.payment(false)
                    window.location.href = payment.replace(":phone", state.user?.phone ?? '').replace(':amount', amount.toString())

                }} onClose={() => {
                    dispatcher.payment(false)
                }} />
            </Box>
        )
    }
}

export default Header